<app-header-loja [titulo]="'Configurações'" [retorno]="'perfil'"></app-header-loja>

<div class="row mt-3" [hidden]="configuracoes == null">
  <div class="col-12">
    <div class="card contato">
      <div class="card-body">
        <p class="alert alert-success" role="alert" *ngIf="msgSucesso">
          <i class="mdi mdi-check-all mr-2"></i>
          <i class="mdi mdi-check-all mr-2"></i>
          <span>{{msgSucesso}}</span>
        </p>

        <div class="form-group">
          <label>Desejo receber promoções e cupons de desconto no Whatsapp?</label>
          <div class="mt-0 mb-1 font-24 valor">
            <kendo-switch name="exibirCardapio" [(ngModel)]="configuracoes.msgsMarketingAtivas"
                          [onLabel]="'Sim'" style="font-size: 12px;"
                          [offLabel]="'Não'"></kendo-switch>
          </div>
        </div>

        <hr>
        <button type="button" class="btn btn-primary" (click)="salvar()">
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
